import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import CannerView from "./views/CannerView.tsx";
import { DataProvider } from "./state/store.tsx";
import "./index.css";

// A canner opens the app via a scoped link (?ct=<token>) — render only the restricted canner view.
// Everyone else gets the owner app (password-gated).
const token = new URLSearchParams(window.location.search).get("ct") || "";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {token ? <CannerView token={token} /> : <DataProvider><App /></DataProvider>}
  </React.StrictMode>,
);
